import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroupDirective } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { LoginService } from '../../services/login/login.service';
//import { ClaimantService } from '../../../services/claimant/claimant.service';
//import { Claimant } from '../../../models/claimant';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ToastrService } from 'ngx-toastr';
import { Authenticate } from '../../models/authenticate';



@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrls: ['./login.css'],
  imports: [RouterModule, ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule, BsDatepickerModule],
})
export class Login {

  // Used to clear validation error states on Material form controls
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;

  loginInformation: FormGroup;
  authenticate: any;
  message: '';
  submitted = false;
  clicked = false;
  tempVar: number;
  showDivHasFiled: boolean = false;


  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private _router: Router,
    private storage: LocalStorageService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,

  ) { }
  ngOnInit() {
    this.loginInformation = this.fb.group({
      uniqueId: ["", Validators.compose([Validators.required, Validators.maxLength(8), Validators.minLength(8), Validators.pattern("^[a-zA-Z0-9]+$")])],
      pin: ["", Validators.compose([Validators.required, Validators.maxLength(6), Validators.minLength(6), Validators.pattern("^[a-zA-Z0-9]+$")])],    })
  }

  get f() { return this.loginInformation.controls; }
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginInformation.invalid) {
      this.clicked = false;
      return;
    }

    this.clicked = true;
    const au = this.loginInformation.value;

    this.spinner.show();

    this.Login(au);
  }

  Login(au: Authenticate) {
    this.loginService.login(au).subscribe({
      next: (res) => {
        this.authenticate = res;

        if (this.authenticate.hasFiled === false) {
          this.storage.store('authenticatedUser', this.authenticate);
          this._router.navigate(['/file']);
        }
        else if (this.authenticate.hasFiled === true) {
          this.showDivHasFiled = true;

          this.toastr.error('You have already submitted your documents', 'Info Already Saved', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        }

        // cleanup
        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
        this.loginInformation.get('uniqueId').clearValidators();
        this.loginInformation.get('uniqueId').updateValueAndValidity();
        this.loginInformation.get('pin').clearValidators();
        this.loginInformation.get('pin').updateValueAndValidity();
      },

      error: (err) => {
        if (err.status === 404) {
          this.toastr.error('User not found', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        } else {
          this.toastr.error('Something went wrong, Please Check Again', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        }

        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
      }
    });
  }
}

